import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import FocusOn from "../../ui/FocusOn/FocusOn";
export var FocusOnModal = function (_a) {
    var focusOn = _a.focusOn, afterClose = _a.afterClose;
    var afterCloseRef = useRef(afterClose);
    afterCloseRef.current = afterClose;
    useEffect(function () {
        return function () {
            var _a;
            (_a = afterCloseRef.current) === null || _a === void 0 ? void 0 : _a.call(afterCloseRef);
        };
    }, []);
    return (_jsx(_Fragment, { children: _jsx(FocusOn, { item: focusOn }) }));
};
export var getFocusOnModalProps = function () {
    return {
        noLogo: true
    };
};
